import { IoCloseOutline as Close } from 'react-icons/io5';
import { BsDownload as Download } from 'react-icons/bs';
import fileDownload from 'js-file-download';
import { useReduxFileStorage } from '@Hooks/reduxFileStorageHook/useReduxFileStorage';
import '@Partials/_ComStyles.scss';
import '@Partials/_SimpleStyles.scss';
import './FileFrame.scss';

export default function FileFrame(props) {

    const { downloadFileFromUrl } = useReduxFileStorage();
    const className = 'fileFrame';

    const dataURLtoFile = (dataurl) => {
        var arr = dataurl.split(','),
            mime = arr[0].match(/:(.*?);/)[1],
            bstr = atob(arr[1]),
            n = bstr.length,
            u8arr = new Uint8Array(n);
        while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
        }
        return new File([u8arr], { type: mime });
    };

    const downloadFile = async() => {
        downloadFileFromUrl(props.file?.publicUrl, props.file.fileName);
    }

    return (
        <div className={className} >
            {
                (props.fileType?.indexOf('image') > -1) &&
                <div className={className + '__image flex-row-flex-start'}>
                    <div className={className + '__image__inner flex-column-flex-start'}>
                        <img
                            src={props.file?.publicUrl}
                            className={className + '__image__display'}
                            alt={props.file?.fileName}/>
                    </div>
                </div>
            }
            {
                (props.fileType?.indexOf('video') > -1) &&
                <div className={className + '__video flex-row-flex-start'}>
                    <div className={className + '__video__inner flex-column-flex-start'}>
                        {
                            !!props.file?.file &&
                                <>
                                    <video
                                        className={className + '__video__display'}
                                        controls
                                        src={props.file?.publicUrl}
                                    />
                                </>
                        }
                    </div>
                </div>
            }
            {
                (props.fileType?.indexOf('pdf') > -1) &&
                <div className={className + '__pdf flex-row-flex-start'}>
                    <div className={className + '__pdf__inner flex-column-flex-start'}>
                        <object data={props.file?.publicUrl} type='application/pdf'/>
                    </div>
                </div>
            }
            {
                    (props.fileType?.indexOf('pdf') === -1) && (props.fileType?.indexOf('video') === -1) && (props.fileType?.indexOf('image') === -1) &&
                    <div className={className + '__noPreview flex-row-flex-start'}>
                        <div className={className + '__noPreview__inner flex-column-flex-start'}>
                            No Preview Available
                        </div>
                    </div>

            }
            <div className={className + '__file__name flex-row-center-space-between'}>
                <div className={className + '__file__name__fileName'}>
                    {props.file?.fileName}
                </div>
                <div className={className + '__file__name__options flex-row-center-1vw-gap'}>
                    <Download className={className + '__file__download dashboard-icon standard-link'} onClick={() => downloadFile()}/>
                    {
                        props.showClose &&
                        <Close className={className + '__file__delete dashboard-icon standard-link'} onClick={() => props.deleteFile(props.file?.fileName)}/>
                    }
                </div>
            </div>
        </div>
    );
}
    